import React from 'react';
import { connect } from 'react-redux';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { browserTime } from '../../utils/parsing';
import { getBuildingName as gbn } from '../../redux/selectors/buildings';
import ResultsViewer from '../analyticsQa/ResultsViewer';
import Target from '../actionLog/Target';

import '../actionLog/action-table.css';

/* eslint-disable camelcase */

const ChangesTable = ({ logItems, getBuildingName }) => (
  <div className="action-table">
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Site</TableCell>
          <TableCell>Time</TableCell>
          <TableCell>Action</TableCell>
          <TableCell>User</TableCell>
          <TableCell>Details</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {logItems.map((action) => (
          <TableRow key={action.id} hover>
            <TableCell>{getBuildingName(action.target_id)}</TableCell>
            <TableCell>{browserTime(action.timestamp)}</TableCell>
            <TableCell>
              <span className="code">{action.action}</span>
            </TableCell>
            <TableCell>
              <Target type="user" id={action.user_id} />
            </TableCell>
            <TableCell>
              <ResultsViewer results={action.details} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default connect((state) => ({
  getBuildingName: (bid) => gbn(state, bid),
}))(ChangesTable);
